import { createSelector } from 'reselect';

const selectIntroTour = state => state.get('introTour');

export const selectTourActive = () =>
  createSelector(selectIntroTour, data => data.get('active'));
